export enum TENANT_TYPE {
  enterprise = 'ENTERPRISE',
  platformOperator = 'PLATFORM_OPERATOR',
  serviceProvider = 'SERVICE_PROVIDER',
  user = 'USER',
  superadmin = 'SUPER_ADMIN',
}
